import axios from 'axios'
import config from '../../config'

const APIURL = config.apiUrl;

let ContactApi = {
  postMessage (model) {
    return axios.post(APIURL + 'contact/v2', model);
  },
};

export default ContactApi;



// WEBPACK FOOTER //
// ./src/api/Contact/index.js